import { api } from "./api";


export const translationJobListApi = (params) => {
    return api.get(`/hub/translation-job/list`, { params: params });
};

